import React from 'react'
import { cx } from '@emotion/css'
import { styles, placement, size, sticky } from './styles'
import PropTypes from 'prop-types'

const MiniModal = ({ open, trigger, children, className, onToggle, onClickOutside, triggerRef, ...props }) => {
  const ref = React.useRef(null)
  const [didInit, setDidInit] = React.useState(false)
  const clickOrTouchListener = React.useCallback(
    e => {
      if (ref && ref.current && e.target !== triggerRef?.current) {
        if (!ref.current.contains(e.target) && open) {
          onClickOutside && onClickOutside(e)
        }
      }
    },
    [triggerRef?.current, ref.current, onClickOutside, open],
  )
  React.useEffect(() => {
    if (!didInit && open) {
      document.addEventListener('click', clickOrTouchListener, {
        capture: true,
      })
      setDidInit(true)
    }
  }, [didInit, open])

  React.useEffect(() => {
    return () => {
      document.removeEventListener('click', clickOrTouchListener)
    }
  }, [])

  return (
    <div className={styles.filterWrapper}>
      <div onClick={onToggle}>{trigger}</div>
      {open === true && (
        <div className={cx(styles.wrapper, sticky(props.sticky), placement(props.placement), size(props.size), className)}>
          <div className={styles.body} ref={ref}>
            {children}
          </div>
        </div>
      )}
    </div>
  )
}

MiniModal.propTypes = {
  open: PropTypes.bool,
  roles: PropTypes.array,
  trigger: PropTypes.object,
  onToggle: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.element])),
  ]),
  sticky: PropTypes.bool,
  placement: PropTypes.string,
  size: PropTypes.string,
  onClickOutside: PropTypes.func,
  triggerRef: PropTypes.object,
}

export default MiniModal
